export default "data:image/webp;base64,UklGRj4AAABXRUJQVlA4TDEAAAAvJ4AGACATsAikrTLCCONbAgdBts38UQYzlSOcMNsIawaT3uvIrv8TYOR1+3GWgv8BAA=="